import $ from 'jquery';

/**
 * Alerte de retour en stock par déclinaison (cards et tableau).
 * Les boutons ouvrent une modale unique qui porte le formulaire ps_emailalerts,
 * ce qui évite de dupliquer le champ e-mail et le consentement RGPD par déclinaison.
 */
export default class ProductMailAlert {
  constructor() {
    this.registered = new Set();
  }

  init() {
    this.modal = $('#mailalert-modal');

    if (!this.modal.length) {
      return;
    }

    // Délégation : le tableau des déclinaisons est re-rendu en AJAX par wkproductcombinationview
    $(document).on('click', '.js-mailalert-open', (event) => this.open($(event.currentTarget)));
    $(document).ajaxComplete(() => this.applyRegistered());

    this.modal.find('.js-mailalert-form').on('submit', (event) => {
      event.preventDefault();
      this.submit();
    });

    this.syncAvailabilityAlert();
  }

  /**
   * Mobile : le rafraîchissement AJAX du cœur ne resynchronise que `.add`, le sélecteur
   * de quantité voisin survit donc à l'arrivée de l'alerte. On marque le conteneur pour
   * que le SCSS masque la quantité. À rappeler après chaque `updatedProduct`.
   */
  syncAvailabilityAlert() {
    const container = $('.js-product-add-to-cart');
    const hasAlert = container.find('.js-mailalert-open, .js-mailalert-registered').length > 0;

    container.toggleClass('has-availability-alert', hasAlert);
  }

  open(button) {
    const label = String(button.data('combination-name') || '').replace(/(\s*-\s*)+$/, '');

    this.modal.find('.js-mailalert-id-product').val(button.data('id-product'));
    this.modal.find('.js-mailalert-id-product-attribute').val(button.data('id-product-attribute'));
    this.modal.find('.js-mailalert-combination').text(label);
    this.setMessage('', false);
    this.modal.modal('show');
  }

  submit() {
    const form = this.modal.find('.js-mailalert-form');
    const idProductAttribute = String(form.find('.js-mailalert-id-product-attribute').val());

    $.post(form.attr('action'), form.serialize())
      .done((response) => {
        let result;

        try {
          result = typeof response === 'string' ? JSON.parse(response) : response;
        } catch (error) {
          this.setMessage(this.modal.data('error-label'), false);
          return;
        }

        this.setMessage(result.message, !result.error);

        if (!result.error) {
          this.registered.add(idProductAttribute);
          this.applyRegistered();
        }
      })
      .fail(() => this.setMessage(this.modal.data('error-label'), false));
  }

  // Remplace les boutons des déclinaisons souscrites pendant la visite
  applyRegistered() {
    if (!this.registered.size) {
      return;
    }

    const label = this.modal.data('registered-label');

    this.registered.forEach((idProductAttribute) => {
      $(`.js-mailalert-open[data-id-product-attribute="${idProductAttribute}"]`)
        .replaceWith($('<p class="mailalert-registered js-mailalert-registered"></p>').text(label));
    });
  }

  setMessage(text, success) {
    const message = this.modal.find('.js-mailalert-message');

    message.removeClass('alert alert-success alert-danger').empty();

    if (text) {
      message.addClass(`alert alert-${success ? 'success' : 'danger'}`).text(text);
    }
  }
}
